
import { Component, Vue, Prop } from 'vue-property-decorator'
import { delObjEmptyKey, jsonToObjArr } from '@/utils'

@Component({
  name: 'logDetails',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) logDetails!: any
  private downstream_request: any[] = []
  private downstream_reponse: any[] = []
  mounted () {
    this.downstream_request = jsonToObjArr(this.logDetails.downstream_request)
    this.downstream_reponse = jsonToObjArr(this.logDetails.downstream_reponse)
  }
}
